import * as tslib_1 from "tslib";
/* I29 in DS */
// from GDrive
import React from 'react';
import IconWrap from '../IconWrap';
var Trashcan = /** @class */ (function (_super) {
    tslib_1.__extends(Trashcan, _super);
    function Trashcan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Trashcan.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                    React.createElement("path", { d: "M10.3748712,5.01343777 L14.5251288,5.01343777 L14.5251288,3.68502331 L10.3748712,3.68502331 L10.3748712,5.01343777 Z M5.32815789,6.00949961 L5.32815789,7.33758205 L6.92185683,7.33758205 L6.92185683,19.4560023 L17.9781432,19.4560023 L17.9781432,7.33758205 L19.5718421,7.33758205 L19.5718421,6.00949961 L5.32815789,6.00949961 Z M13.3281579,16.4582438 L14.6562403,16.4582438 L14.6562403,9.68502331 L13.3281579,9.68502331 L13.3281579,16.4582438 Z M10.1424568,16.4017447 L11.4708712,16.4017447 L11.4708712,9.62852427 L10.1424568,9.62852427 L10.1424568,16.4017447 Z", fill: "currentColor" })))));
    };
    return Trashcan;
}(React.Component));
export { Trashcan };
export default Trashcan;
//# sourceMappingURL=Trashcan.js.map